import { get } from 'lodash'

// app selectors
export const getAboutContent = content => content.pages.about
export const getProgramContent = content => content.pages.program
export const getSponsorsContent = content => content.pages.sponsors
export const getVenueContent = content => content.pages.venue
export const getPresentations = content =>
  Object.values(content.data.presentations)
export const getTracks = content => Object.values(content.data.tracks)
export const getSessions = content => content.data.sessions
export const getNavigationLabels = content => content.navigation.labels
export const getNavigationIcons = content => content.navigation.icons
export const getNavigationItems = content => content.navigation.items
export const getAppTitle = content => content.general.appTitle
export const getPresentation = (content, id) => content.data.presentations[id]
export const getTrack = (content, id) => content.data.tracks[id]
export const getMessages = content => content.intl.messages
export const getPreferredLocales = content => content.intl.preferredLocales
export const getFeedbackCfg = content => content.addons.feedback.cfg
export const getFeedbackDefinition = (content, type) =>
  content.addons.feedback.definitions[type]
export const getSocialShareDefinition = (content, type) =>
  content.addons.socialShare.definitions[type]
export const getTheme = content => content.theme
export const getChatCfg = content => get(content, 'addons.chat.cfg')
export const getPresentationChatroom = (content, pid) =>
  get(content, ['addons', 'chat', 'definitions', 'presentation', 'rooms', pid])

export const getGlobalChatroom = (content, pid) =>
  get(content, ['addons', 'chat', 'definitions', 'global', 'room'])
export const getChatAdminUser = (content, key) =>
  content.addons.chat.admins.find(a => a.urlKey === key)



// WEBPACK FOOTER //
// ./src/app/selectors.js